import { render, staticRenderFns } from "./LowCostAccess.vue?vue&type=template&id=08a14694&scoped=true&"
import script from "./LowCostAccess.vue?vue&type=script&lang=js&"
export * from "./LowCostAccess.vue?vue&type=script&lang=js&"
import style0 from "./LowCostAccess.vue?vue&type=style&index=0&id=08a14694&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a14694",
  null
  
)

export default component.exports